import React, { useEffect, useState } from 'react';
import { Badge, IconButton, Popover, Typography, List, ListItem, ListItemText } from '@material-ui/core';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { useMessages } from '../contexts/MessageContext';

const NotificationBadge = () => {
    const { unreadCount } = useMessages();
    const [anchorEl, setAnchorEl] = useState(null);
    const [notifications, setNotifications] = useState([]);

    useEffect(() => {
        if (unreadCount > 0) {
            // In a real app, you might fetch actual notifications here
            setNotifications([
                { id: 1, text: `You have ${unreadCount} unread messages` }
            ]);
        } else {
            setNotifications([]);
        }
    }, [unreadCount]);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'notification-popover' : undefined;

    return (
        <>
            <IconButton color="inherit" onClick={handleClick}>
                <Badge badgeContent={unreadCount} color="error">
                    <NotificationsIcon />
                </Badge>
            </IconButton>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <List style={{ width: '300px' }}>
                    {notifications.length > 0 ? (
                        notifications.map((notification) => (
                            <ListItem key={notification.id}>
                                <ListItemText primary={notification.text} />
                            </ListItem>
                        ))
                    ) : (
                        <ListItem>
                            <ListItemText primary="No new notifications" />
                        </ListItem>
                    )}
                </List>
            </Popover>
        </>
    );
};

export default NotificationBadge;